export default{
    async changeEmailHome({}, email){
        let result = null;
        await this.$axios.$post(
            this.$api.user.userConfig.chgEmailHome,
            email
        )
        .then(response => {
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },
}